import React from 'react';

import {Action, ActionProps} from '../Action/index.ts';
import { EditCalendar } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

export function Reschedule(props: ActionProps) {
  return (
    <Action
      {...props}
      active={{
        fill: 'rgba(255, 70, 70, 0.95)',
        background: 'rgba(255, 70, 70, 0.1)',
      }}
    >
      <Tooltip title='Reschedule all items to the beginning of the currently displayed calendar period'>
        <EditCalendar fontSize='20px'/>
      </Tooltip>
    </Action>
  );
}

export default Reschedule;